import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AlternativeSolutionCard } from '../../ng-for-business.models';

@Component({
  selector: 'app-ng-business-alt-solutions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alt-solutions.component.html',
  styleUrls: ['./alt-solutions.component.scss'],
})
export class AltSolutionsComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) cards!: AlternativeSolutionCard[];
  @Input({ required: true }) note!: string;

  trackByCard = (_: number, card: AlternativeSolutionCard) => card.image;
}
